import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Slide, Snackbar } from "@mui/material";
export * from './SnackbarState.type';
export var SnackBarUI = function (_a) {
    var snackbar = _a.snackbar, onClose = _a.onClose;
    function SlideTransition(props) {
        return _jsx(Slide, __assign({}, props, { direction: "up" }));
    }
    return (snackbar && _jsx(Snackbar, { open: snackbar === null || snackbar === void 0 ? void 0 : snackbar.open, autoHideDuration: (snackbar === null || snackbar === void 0 ? void 0 : snackbar.autoHideDuration) || 3000, message: snackbar === null || snackbar === void 0 ? void 0 : snackbar.message, onClose: onClose }, SlideTransition.name));
};
